/* eslint-disable jsx-a11y/label-has-for */
import React, { useEffect, useState } from 'react';
import { PropTypes } from 'prop-types';
import { setValue } from '../../../../store/actions';
import useComponent from '../../../../hooks/useComponent';

const TextArea = ({ title, name, dispatch, defaultValue }) => {
  const [inputValue, setInputValue] = useState();
  const [inputError, setInputError] = useState(false);

  const handleTextArea = (e) => {
    const { value, name } = e.target;
    setInputValue(value);

    try {
      setValue(dispatch)(name, JSON.parse(value));
      setInputError(false);
    } catch (err) {
      setInputError(true);
    }
  };

  useEffect(() => {
    setInputValue(JSON.stringify(defaultValue, undefined, 4));
  }, [defaultValue]);

  return (
    <>
      <label className="block uppercase tracking-wide text-black text-xs font-bold mr-2" htmlFor={name}>
        {`${title} `}
        {inputError && (
          <span className="text-red">
            Invalid JSON
          </span>
        )}
      </label>

      <textarea
        className="font-americaMonoRegular appearance-none block w-full h-125px bg-gray-200 text-gray-700 border border-red-500 rounded py-3 px-4 my-3 leading-tight focus:outline-none focus:bg-white"
        onChange={handleTextArea}
        value={inputValue}
        name={name}
        type="text"
      />
    </>
  );
};


const initialState = {
  data: {
    type: 'MapData',
    data: {},
    info: {},
    config: {},
    title: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
  },
  error: false,
};

const MapData = ({
  handlerSetComponents, components, id, reusableComponent,
}) => {
  const { state: { data }, dispatch } = useComponent({ initialState, setComponents: handlerSetComponents, components, id, reusableComponent });

  return (
    <div className="flex flex flex-wrap w-full">
      <div className="flex flex-row w-full md:w-full md:mb-0 mt-2">
        <div className="w-full pr-4">
          <TextArea
            title="Post info"
            name="info"
            defaultValue={data.info}
            dispatch={dispatch}
          />
        </div>
      </div>

      <div className="w-full flex items-center my-3">
        <div className="w-full pr-4">
          <TextArea
            title="Post data"
            name="data"
            defaultValue={data.data}
            dispatch={dispatch}
          />
        </div>
      </div>

      <div className="w-full flex items-center my-3">
        <div className="w-full pr-4">
          <TextArea
            title="Post config"
            name="config"
            defaultValue={data.config}
            dispatch={dispatch}
          />
        </div>
      </div>
    </div>
  );
};

TextArea.defaultProps = {
  title: PropTypes.string,
  name: PropTypes.string,
  dispatch: PropTypes.func,
  defaultValue: PropTypes.shape({}),
};

TextArea.propTypes = {
  title: PropTypes.string,
  name: PropTypes.string,
  dispatch: PropTypes.func,
  defaultValue: PropTypes.shape({}),
};

MapData.propTypes = {
  handlerSetComponents: PropTypes.func.isRequired,
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  id: PropTypes.string.isRequired,
  reusableComponent: PropTypes.shape(),
};

MapData.defaultProps = {
  reusableComponent: null,
};

export default MapData;
